import * as Types from '../../../../../../generated/graphql/types';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuthGetLearningSessionQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AuthGetLearningSessionQueryQuery = { __typename?: 'Query', security: { __typename?: 'SecurityQuery', current_session?: { __typename?: 'UserSession', learning_session?: { __typename?: 'LearningSession', organization_id?: string | null, user_id?: string | null } | null } | null } };


export const AuthGetLearningSessionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthGetLearningSessionQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"security"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"learning_session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useAuthGetLearningSessionQueryQuery__
 *
 * To run a query within a React component, call `useAuthGetLearningSessionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthGetLearningSessionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthGetLearningSessionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthGetLearningSessionQueryQuery(baseOptions?: Apollo.QueryHookOptions<AuthGetLearningSessionQueryQuery, AuthGetLearningSessionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthGetLearningSessionQueryQuery, AuthGetLearningSessionQueryQueryVariables>(AuthGetLearningSessionQueryDocument, options);
      }
export function useAuthGetLearningSessionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthGetLearningSessionQueryQuery, AuthGetLearningSessionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthGetLearningSessionQueryQuery, AuthGetLearningSessionQueryQueryVariables>(AuthGetLearningSessionQueryDocument, options);
        }
export type AuthGetLearningSessionQueryQueryHookResult = ReturnType<typeof useAuthGetLearningSessionQueryQuery>;
export type AuthGetLearningSessionQueryLazyQueryHookResult = ReturnType<typeof useAuthGetLearningSessionQueryLazyQuery>;
export type AuthGetLearningSessionQueryQueryResult = Apollo.QueryResult<AuthGetLearningSessionQueryQuery, AuthGetLearningSessionQueryQueryVariables>;